export default __webpack_public_path__ + "static/media/logout-icon.4cdc0a51.svg";